@for (iconName of iconNames; track iconName) {
  <div>
    <icon [name]="iconName"></icon>
    <span>{{iconName}}</span>
  </div>
}